import type { StrapiEntity } from '../../types/strapi'
import type { TechnologyPageAttributes } from '../../types/siteData'
import { Link, Box, ListItemText } from '@mui/material'

type SearchItemProps = {
  item?: StrapiEntity<TechnologyPageAttributes>
}

const SearchItem = ({ item }: SearchItemProps) => {
  if (!item?.attributes) return null

  const { slug, technologyName } = item.attributes

  return (
    <Link href={`/products/${slug}`} underline="none">
      <Box sx={{ backgroundColor: '#FFF', color: '#000', padding: '10px' }}>
        <ListItemText primary={technologyName} />
      </Box>
    </Link>
  )
}

export default SearchItem
